<template>
  <div id="operate">
    <div class="banner">
      <div class="top_btn" @click="toBottom">立即联系</div>
    </div>
    <div class="service">
      <div class="title">
        <img
          class="txt_img"
          src="../../../assets/image/h5operate/ziti_01.png"
          alt=""
        />
        <p class="text">已为<span>800+</span>企业提供新媒体代运营服务</p>
        <p class="line"></p>
      </div>
      <div class="service_box">
        <div class="list_box">
          <div class="logo_box">
            <img
              class="hong"
              src="../../../assets/image/h5operate/xiaohongshuicon.png"
              alt=""
            />
          </div>
          <p>小红书代运营</p>
        </div>
        <div class="list_box">
          <div class="logo_box">
            <img
              class="dou"
              src="../../../assets/image/h5operate/douyinicon.png"
              alt=""
            />
          </div>
          <p>抖音代运营</p>
        </div>
        <div class="list_box">
          <div class="logo_box">
            <img
              class="xin"
              src="../../../assets/image/h5operate/xinmeiti.png"
              alt=""
            />
          </div>
          <p>新媒体整合运营</p>
        </div>
        <div class="list_box">
          <div class="logo_box">
            <img
              class="wei"
              src="../../../assets/image/h5operate/weixinicon.png"
              alt=""
            />
          </div>
          <p>微信代运营</p>
        </div>
        <div class="list_box">
          <div class="logo_box">
            <img
              class="bo"
              src="../../../assets/image/h5operate/weiboicon.png"
              alt=""
            />
          </div>
          <p>微博代运营</p>
        </div>
        <div class="list_box">
          <div class="logo_box">
            <img
              class="gong"
              src="../../../assets/image/h5operate/liebian.png"
              alt=""
            />
          </div>
          <p>公众号合作</p>
        </div>
      </div>
      <div class="operate">
        <div class="title">
          <img
            class="txt_img"
            src="../../../assets/image/h5operate/ziti_02.png"
            alt=""
          />
          <p class="text">运营方法论，助力企业成长</p>
          <p class="line"></p>
        </div>
        <div class="swipers" id="operateSwiper">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            style="padding: 28px 20px 5px;"
          >
            <swiper-slide>
              <div class="operate_box">
                <img
                  class="top_img"
                  src="../../../assets/image/h5operate/icon_yunyingguan.png"
                  alt=""
                />
                <p>品牌定位分析</p>
                <div class="cont_box">
                  <div class="lists_box">
                    <p>品牌现状诊断</p>
                    <p>
                      技术评估，针对客户的需求提出可行性的诊断与优化的建议。
                    </p>
                  </div>
                  <div class="lists_box">
                    <p>品牌定位规划</p>
                    <p>
                      结合客户品牌、平台情况及推广方向做营销推广方案/脑图/简报。
                    </p>
                  </div>
                  <div class="lists_box">
                    <p>品牌落地执行</p>
                    <p>
                      结合简报方案，有序的主动的与甲方客户对接细节，推送内容，推送活动。
                    </p>
                  </div>
                </div>
                <div class="bot_btn">
                  <div class="btn_l" @click="toBottom">立即咨询</div>
                  <div class="btn_r" @click="toBottom">免费诊断</div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="operate_box">
                <img
                  class="top_img"
                  src="../../../assets/image/h5operate/icon_neirongcehuayunying.png"
                  alt=""
                />
                <p>内容策划与运营</p>
                <div class="cont_box">
                  <div class="list_box">
                    <p>内容策划及脚本撰写</p>
                    <p>根据热点节气结合品牌调性进行内容规划创意，</p>
                  </div>
                  <div class="list_box">
                    <p>创意H5</p>
                    <p>制作交互动态的海报宣传物料</p>
                  </div>
                  <div class="list_box">
                    <p>反馈表单</p>
                    <p>制作可以收集客户信息的表单</p>
                  </div>
                  <div class="list_box">
                    <p>内容策划及脚本撰写</p>
                    <p>根据热点节气结合品牌调性进行内容规划创意，</p>
                  </div>
                </div>
                <div class="bot_btn">
                  <div class="btn_l" @click="toBottom">立即咨询</div>
                  <div class="btn_r" @click="toBottom">免费诊断</div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="operate_box">
                <img
                  class="top_img"
                  src="../../../assets/image/h5operate/icon_1.png"
                  alt=""
                />
                <p>平台账号分析</p>
                <div class="cont_box">
                  <div class="list_box">
                    <p>转化率</p>
                    <p>形成矩阵效应，提高转化率，进行变现，</p>
                  </div>
                  <div class="list_box">
                    <p>互动率</p>
                    <p>引爆话题，提高趣味性，拉热度/脑图/简报。</p>
                  </div>
                  <div class="list_box">
                    <p>浏览率</p>
                    <p>抓精准用户，增强曝光率</p>
                  </div>
                  <div class="list_box">
                    <p>点赞量</p>
                    <p>抓住用户心理，引爆流量</p>
                  </div>
                </div>
                <div class="bot_btn">
                  <div class="btn_l" @click="toBottom">立即咨询</div>
                  <div class="btn_r" @click="toBottom">免费诊断</div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="advantage">
        <div class="title">
          <img
            class="txt_img"
            src="../../../assets/image/h5operate/ziti_advantage.png"
            alt=""
          />
          <p class="text">我们的优势</p>
          <p class="line"></p>
        </div>
        <div class="advantage_box">
          <div class="box_list">
            <div class="list_box">
              <div class="list_top">
                <img src="../../../assets/image/h5operate/icon_01.png" alt="" />
                <span>社媒定位</span>
              </div>
              <p>多维度内容策略提升账号销售力</p>
            </div>
            <div class="list_box">
              <div class="list_top">
                <img src="../../../assets/image/h5operate/icon_02.png" alt="" />
                <span>爆文转化</span>
              </div>
              <p>多维度内容策略提升账号销售力</p>
            </div>
            <div class="list_box">
              <div class="list_top">
                <img src="../../../assets/image/h5operate/icon_03.png" alt="" />
                <span>私域构建</span>
              </div>
              <p>搭建私域流量，强化粉丝互动</p>
            </div>
            <div class="list_box">
              <div class="list_top">
                <img src="../../../assets/image/h5operate/icon_04.png" alt="" />
                <span>销售转化</span>
              </div>
              <p>利用销售工具，进行转化销售，倍增销量</p>
            </div>
            <div class="center_img">
              <img
                src="../../../assets/image/operate/icon_4dajiazhiyoushi.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="project">
        <div class="title">
          <img
            class="txt_img"
            src="../../../assets/image/h5operate/anli_ziti.png"
            alt=""
          />
          <p class="text">成功案例</p>
          <p class="line"></p>
        </div>
        <div class="case_box">
          <div class="case_list">
            <div class="case">
              <img src="../../../assets/image/h5operate/momo_tu.png" alt="" />
              <div class="text">
                <p>武笑天-职场江湖</p>
                <p>职场/创业/人性，带你聊聊那些职场江湖事</p>
              </div>
            </div>
            <div class="case">
              <img src="../../../assets/image/h5operate/tu_02.png" alt="" />
              <div class="text">
                <p>你好，Hea！</p>
                <p>
                  hea唧本意为找寻、探索、发现
                  所以我哋喺嘻哈唧马尔代夫——广州，搞咗啲事。
                  一件专注潮流文化唧club
                  邀请你，同我哋一起探索音乐中唧记忆同美好
                </p>
              </div>
            </div>
            <div class="case">
              <img src="../../../assets/image/h5operate/tu_03.png" alt="" />
              <div class="text">
                <p>胡闹星球</p>
                <p>
                  每张照片 都有一段属于它的故事 有些情感 其实需要用酒精去酝酿
                  在这里… 总有一点故事能扣你心弦
                </p>
              </div>
            </div>
            <div class="case">
              <img src="../../../assets/image/h5operate/tu_04.png" alt="" />
              <div class="text">
                <p>TCH旗舰店</p>
                <p>TCH 轻奢潮牌 潮流文化基因</p>
              </div>
            </div>
            <div class="case">
              <img src="../../../assets/image/h5operate/tu_05.png" alt="" />
              <div class="text">
                <p>吾小历</p>
                <p>时尚博主</p>
              </div>
            </div>
            <div class="case">
              <img src="../../../assets/image/h5operate/tu-06.png" alt="" />
              <div class="text">
                <p>侯浩在巴蜀</p>
                <p>不负韶华 皆是良景 爷爷的柴米油盐与婆婆的诗同在</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="process">
        <div class="title">
          <img
            class="txt_img"
            src="../../../assets/image/h5operate/ziti_liucheng.png"
            alt=""
          />
          <p class="text">规范化<span>服务流程</span>，创造最佳商业内容</p>
          <p class="line"></p>
        </div>
        <div class="process_box">
          <p class="text2">日常运营</p>
          <p class="text4">活动策划</p>
          <p class="text6">商业变现</p>
          <img src="../../../assets/image/h5operate/liucheng_sy.png" alt="" />
          <p class="text1">账号认证</p>
          <p class="text3">内容制作</p>
          <p class="text5">粉丝积累</p>
        </div>
      </div>
      <div class="form">
        <img
          class="bg_top"
          src="../../../assets/image/h5operate/bg_zanghaomianfei.png"
          alt=""
        />
        <div class="form_box" id="signform">
          <p>申请账号免费诊断</p>
          <p>填写资料后客服人员会主动联系您，为您账号免费诊断</p>
          <el-form class="list" :model="FormData" :rules="rules" ref="FormData">
            <el-form-item class="min_input" prop="company_name">
              <label for="">企业名称：<span>*</span></label>
              <el-input maxlength="15" placeholder="请输入企业名称" v-model="FormData.company_name" ></el-input>
            </el-form-item>
            <el-form-item class="min_input" prop="name">
              <label for="">联系人姓名：<span>*</span></label>
              <el-input maxlength="11" placeholder="请输入联系人姓名" v-model="FormData.name"></el-input>
            </el-form-item>
            <el-form-item class="min_input"  prop="phone">
              <label for="">联系人电话：<span>*</span></label>
              <el-input maxlength="11" placeholder="请输入联系人电话" v-model.trim="FormData.phone" ></el-input>
            </el-form-item>
            <el-form-item class="min_input" prop="wx_number">
              <label for="">联系人微信：<span>*</span></label>
              <el-input maxlength="15" placeholder="请输入联系人微信" v-model="FormData.wx_number" ></el-input>
            </el-form-item>
            <el-form-item class="min_input" prop="content">
              <label for="">其他需求：<span>*</span></label>
              <el-input maxlength="300" resize="none" type="textarea" v-model="FormData.content" placeholder="请输入其他需求" ></el-input>
            </el-form-item>
            <el-form-item class="btn_box">
              <el-button class="next"  @click="submitForm('FormData')">提交</el-button>
            </el-form-item>
          </el-form>
         
        </div>
        <a href="https://beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank" rel="noreferrer">四川省成都市博雅城市广场A座1105 蜀ICP备2020032209号</a>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  metaInfo() {
    return this.metaData;
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === '') {
        return callback(new Error('请输入手机号码'))
      } else if (phoneReg.test(value)) {
        return callback()
      } else {
        return callback(new Error('请输入正确手机号码'))
      }
    }
    return {
      swiperOption: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        centeredSlides: true,
      },
      FormData:{
        company_name:'',
        phone:'',
        name: '',
        from: '官网',
        wx_number:'',
        content:''
      },
      rules: {
        company_name:[
          { required: true, trigger: 'blur', message: '未填写企业名称' }
        ],
        name:[
          { required: true, trigger: 'blur', message: '未填写姓名' }
        ],
        phone: [
          { required: true, validator: validatePhone }
        ],
        wx_number:[
          { required: true, trigger: 'blur', message: '未填写微信号' }
        ],
        content:[
          { required: true, trigger: 'blur', message: '未填写需求' }
        ],
      },
      metaData: {
        title: "公众号代运营_小红书代运营_抖音代运营_泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content: "公众号代运营、小红书代运营、抖音代运营",
          },
          {
            name: "description",
            content:
              "泽谷传媒新媒体代运营团队,提供微信订阅号|服务号|微博内容运营、小红书代运营、抖音代运营等新媒体运营解决方案:4006520677。",
          },
        ],
      },
    };
  },
  created(){
    this.$emit('showPC', false);
  },
  mounted() {
    if(!this.isMobile(navigator.userAgent)) {
      let url = window.location.origin.replace(/m./, "www.");
      window.location.href= url +'/page/operate/operate.html'
    }
  },
  methods: {
    toBottom(){
      window.scrollTo(0,document.getElementById('app').scrollHeight)
    },
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    },
    submitForm(FormData) {
      this.$refs[FormData].validate((valid) => {
        if(valid) {
          this.$axios.post('/v1/company_info', this.FormData).then(res =>{
            if(res.code === 0) {
              this.FormData.resetFields()
            }
          })
        }
      })
    }
  },
};
</script>
<style lang="scss">
#operate{
  .form{
    
  }
}
</style>
<style lang="scss" scoped>
#operate {
  width: 100%;
  height: 100%;
  .banner {
    height: 55px;
    width: 100%;
    background: url(../../../assets/image/h5operate/bnner_1.png) no-repeat;
    background-size: 100% 100%;
    padding-top: 156px;
    .top_btn {
      width: 130px;
      height: 27px;
      background: #f7b71f;
      box-shadow: 0px 10px 16px 0px rgba(48, 132, 255, 0.3);
      border-radius: 28px;
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 27px;
      margin: 0px auto 0;
    }
  }
  .service {
    .title {
      text-align: center;
      position: relative;
      padding: 30px 0 10px;
      .txt_img {
        position: absolute;
        top: 18px;
        left: 30%;
        width: 37%;
        z-index: -2;
      }
      .text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2b3748;
        z-index: 5;
        margin: 0 auto;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 6px auto;
      }
    }
    .service_box {
      display: flex;
      flex-wrap: wrap;
      padding: 0 15px;
      justify-content: space-between;
      text-align: center;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #616975;
      .list_box {
        width: 30%;
        .logo_box {
          height: 50px;
          .hong {
            width: 55px;
            height: 50px;
            object-fit: scale-down;
          }
          .dou {
            width: 30px;
            height: 50px;
            object-fit: scale-down;
          }
          .xin {
            width: 30px;
            height: 50px;
            object-fit: scale-down;
          }
          .wei {
            width: 30px;
            height: 50px;
            object-fit: scale-down;
          }
          .bo {
            width: 30px;
            height: 50px;
            object-fit: scale-down;
          }
          .gong {
            width: 30px;
            height: 50px;
            object-fit: scale-down;
          }
        }
      }
    }
  }
  .operate {
    background: url(../../../assets/image/h5operate/bg_fangfalun.png) no-repeat;
    background-size: 100% 100%;
    padding-bottom: 20px;
    .title {
      text-align: center;
      position: relative;
      padding: 30px 0 0;
      .txt_img {
        position: absolute;
        top: 18px;
        left: 29%;
        width: 43%;
        z-index: 0;
      }
      .text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2b3748;
        z-index: 5;
        position: absolute;
        top: 22px;
        left: 24%;
        margin: 0 auto;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 16px auto 0;
      }
    }
    .swipers {
      margin: 20px auto;
      .operate_box {
        width: 90%;
        height: 365px;
        background: #ffffff;
        box-shadow: 0px 0px 27px 0px rgba(15, 60, 152, 0.2);
        border-radius: 8px;
        position: relative;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #616975;
        text-align: center;
        padding: 30px 10px 15px;
        .top_img {
          width: 60px;
          height: 60px;
          position: absolute;
          top: 0;
          left: 50%;
          margin-left: -30px;
          margin-top: -30px;
          display: block;
        }
        .cont_box {
          width: 94%;
          background: #fda028;
          border-radius: 5px;
          text-align: left;
          padding: 0 10px;
          margin: 15px auto 0;
          .lists_box {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            padding: 15px 0px;
            p:first-child {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }
            p {
              margin: 0 auto;
            }
          }
          .list_box {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 20px;
            padding: 15px 0px;
            p:first-child {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ffffff;
            }
            p {
              margin: 0 auto;
            }
          }
        }
        .bot_btn {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 15px;
          .btn_l {
            width: 45%;
            height: 35px;
            background: linear-gradient(82deg, #6f63f7, #866aec);
            border-radius: 5px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fffefe;
            text-align: center;
            line-height: 35px;
          }
          .btn_r {
            width: 45%;
            height: 35px;
            background: linear-gradient(82deg, #ff5eb1, #ff73b9);
            border-radius: 5px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #fffefe;
            text-align: center;
            line-height: 35px;
          }
        }
      }
    }
  }
  .advantage {
    .title {
      text-align: center;
      position: relative;
      padding: 30px 0 0;
      .txt_img {
        position: absolute;
        top: 18px;
        left: 29%;
        width: 43%;
        z-index: 0;
      }
      .text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2b3748;
        z-index: 5;
        position: absolute;
        top: 22px;
        left: 40%;
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 16px auto 0;
      }
    }
    .advantage_box {
      padding: 30px 10px 20px;
      .box_list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
      }
      .list_box {
        width: 40%;
        height: 70px;
        box-shadow: 0px 0px 16px 0px rgba(15, 60, 152, 0.2);
        border-radius: 3px;
        background-color: #ffffff;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #616975;
        line-height: 18px;
        padding: 10px;
        .list_top {
          display: flex;
          align-items: center;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #616975;
          > img {
            width: 18px;
            height: 18px;
            display: block;
            margin-right: 5px;
          }
        }
        p {
          margin: 0 auto;
          text-align: left;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
      .list_box:nth-child(1) {
        margin-bottom: 50px;
      }
      .list_box:nth-child(2) {
        margin-bottom: 50px;
      }
      .center_img {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 32%;
        margin-top: -16%;
        margin-left: -17%;
        > img {
          width: 95%;
          height: 100%;
        }
      }
    }
  }
  .project {
    background: url(../../../assets/image/h5operate/bg_chenggonganli.png)
      no-repeat;
    background-size: 100% 100%;
    padding-bottom: 30px;
    .title {
      text-align: center;
      position: relative;
      padding: 30px 0 0;
      .txt_img {
        position: absolute;
        top: 18px;
        left: 29%;
        width: 43%;
        z-index: 0;
      }
      .text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2b3748;
        z-index: 5;
        position: absolute;
        top: 22px;
        left: 41%;
        
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 18px auto 0;
      }
    }
    .case_box {
      margin: 15px 10px 0;
      .case_list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .case {
          width: 48%;
          background-color: #ffffff;
          margin-bottom: 20px;
          > img {
            width: 100%;
            height: 100px;
            object-fit: cover;
          }
          .text {
            padding: 10px 10px;
            p:first-child {
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #616975;
            }
            p {
              margin: 0 auto;
              text-align: left;
              font-size: 12px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #616975;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
  .process {
    margin-bottom: 20px;
    .title {
      text-align: center;
      position: relative;
      padding: 30px 0px 0px;
      .txt_img {
        position: absolute;
        top: 18px;
        left: 30%;
        width: 37%;
        z-index: -2;
      }
      .text {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2b3748;
        z-index: 5;
        span{
          font-size: 16px;
          font-weight: bold;
          color: #6F63F7;
        }
      }
      .line {
        width: 40px;
        height: 6px;
        background: #6f63f7;
        border-radius: 3px;
        margin: 6px auto;
      }
    }
    .process_box {
      padding: 24px 10px 35px;
      position: relative;
      margin-top: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #616975;
      > img {
        width: 95%;
      }
      .text1 {
        position: absolute;
        bottom: 0;
        left: 2%;
      }
      .text2 {
        position: absolute;
        top: 0;
        left: 17%;
      }
      .text3 {
        position: absolute;
        bottom: 0;
        left: 34%;
      }
      .text4 {
        position: absolute;
        top: 0;
        left: 50%;
      }
      .text5 {
        position: absolute;
        bottom: 0;
        right: 24%;
      }
      .text6 {
        position: absolute;
        top: 0;
        right: 8%;
      }
    }
  }
  .form {
    position: relative;
    padding-top: 50px;
    margin: 50px 0 30px;
    .bg_top {
      display: block;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .form_box {
      width: 85%;
      margin: 0 auto;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0px 0px 18px 0px rgba(15,60,152,0.18);
      padding: 20px 10px 15px;
      p:first-child {
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2B3748;
        text-align: center;
        margin-bottom: 15px;
      }
      p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7D8A9C;
        text-align: center;
        margin-bottom: 10px;
      }
      .list {
        .min_input {
          text-align: left;
          font-size: 12px;
          span {
            color: red;
          }
        }
        .btn_box {
          width: 50%;
          height: 38px;
          margin: 10px auto 10px;
          background: #F7B71F;
          box-shadow: 0px 4px 16px 0px rgba(94,82,229,0.3);
          border-radius: 40px;
          text-align: center;
          line-height: 38px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }
    a {
      display: block;
      margin: 20px auto 60px;
      padding-bottom: 60px ;
      color: #333333;
      font-size: 12px;
      text-decoration: none;
      display: block;
      width: 100%;
      margin-bottom: 70px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.form_box {
  .el-form-item__content {
    font-size: 12px;
    line-height: 25px;
  }
  .el-input {
    font-size: 12px;
  }
  .el-input__inner {
    height: 30px;
  }
  .el-button{
    background: #F7B71F;
    border: none;
    color: #FFFFFF;
  }
}
</style>
